import { LinkedAccount } from '@platform-frontend/checkout-drop-in';

export class LinkAccount {
  static readonly type = '[Web-Checkout] Link account';
  constructor(public linkedAccount: LinkedAccount | null, public vendor: string) {}
}
